import DirectoryProxy from '@/store/proxies/directory-proxy';
import { getDirectoryStructure, setDirectoryStructure } from '@/utils/directory';


const actions = {
  getDirTree: ({ commit }) => new DirectoryProxy().getDirTree()
      .then(({ detail }) => {
        commit('GET_DIR_TREE', detail);
      }),
};

const mutations = {
  GET_DIR_TREE(state, payload) {
    setDirectoryStructure(payload);
    state.directoryStructure = getDirectoryStructure();
  },
};


const state = {
  directoryStructure: [],
};

export default {
  namespaced: true,
  actions,
  getters: {},
  mutations,
  state,
};



// WEBPACK FOOTER //
// ./src/store/directory.js